import "./footer.css";
import Terms_of_use_en from "../../assets/download/G1Cash_TermsofUse_240418.pdf";
import Privacy_policy_en from "../../assets/download/G1Cash_PrivacyPolicy_240418.pdf";
import { useNavigate } from "react-router-dom";

const Footer = () => {
    const navigate = useNavigate();

    return (
        <div className="footer">
            <div className="footer-policy">
                <div
                    className="footer-link"
                    onClick={() => {
                        navigate("/agreement/privacy");
                    }}
                >
                    <p>Privacy Policy</p>
                </div>
                <div className="footer-policy-border" />
                <div
                    className="footer-link"
                    onClick={() => {
                        navigate("/agreement/terms");
                    }}
                >
                    <p>Terms of use</p>
                </div>
                <div className="footer-policy-border second" />
                <p>
                    <span>Email :</span> g1cash2024@gmail.com
                </p>
            </div>
            <p className="footer-info-web">{"Copyright © 2025 Acts Co.Ltd All Rights Reserved."}</p>

            <div className="footer-policy-mobile">
                <div>
                    <div className="footer-link" onClick={() => navigate("/agreement/privacy")}>
                        <p>Privacy Policy</p>
                    </div>
                    <div className="footer-policy-border" />
                    <div className="footer-link" onClick={() => navigate("/agreement/terms")}>
                        <p>Terms of use</p>
                    </div>
                </div>
                <div className="footer-policy-border second" />
                <p>
                    <span>Email :</span> g1cash2024@gmail.com
                </p>
            </div>
            <p className="footer-info-mobile">{"Copyright © 2025 Acts Co.Ltd \n All Rights Reserved."}</p>
        </div>
    );
};

export default Footer;
